import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import {useFetch} from "../../../../components/common/FetchProvider";
import { numberToWords } from "../../../../utils/numberToWords";
import { getMonthName, getMonthNameInPortguese, getCurrencyNameByCode, formatNumberToInternational } from "../../../../utils/utils";
import ErrorModal from "./ErrorModal";
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;

const IncomeReport = () => {
    const [loading, setLoading] = useState(false);
    const fetchWrapper = useFetch();
    const [apiData, setApiData] = useState({});
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [currencyString, setCurrencyString] = useState("");
    const [exchangeRateText, setExchangeRateText] = useState("");
    const [convertedKwanzaValue, setConvertedKwanzaValue] = useState("");

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const recitaId = queryParams.get("id");
    const currency = queryParams.get("currency");

    useEffect(() => {
        getRecitaById(recitaId, currency);
    }, []);

    const getRecitaById = async (recitaId, currency) => {
        if (currency !== 'EUR' && currency !== 'USD' && currency !== 'AKZ') {
            setErrorMessage("A moeda é inválida");
            setShowErrorModal(true);
        }
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/recita/${recitaId}`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setApiData(responseData.data);
                    setCurrency(responseData.data);
                }
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    }

    const setCurrency = (responseData) => {
        if (currency === 'USD' || currency === 'EUR') {
            setCurrencyString(responseData.accountCurrency + '/'+currency+'/AKZ');
            let firstExchangeRate = findExchangeRate(currency, responseData.accountCurrency,responseData.exchangeRates);
            if (!firstExchangeRate) {
                setErrorMessage(`Taxa de câmbio não encontrada para ${currency} para ${responseData.accountCurrency} para o mês ${responseData.receivedDate.substring(0, 7)}`);
                setShowErrorModal(true);
                return;
            }
            let firstConvertedAmount =  responseData.amount / firstExchangeRate;

            let secondExchangeRate = findExchangeRate(currency, 'AKZ', responseData.exchangeRates);
            if (!secondExchangeRate) {
                setErrorMessage(`Taxa de câmbio não encontrada para ${currency} para AKZ para o mês ${responseData.receivedDate.substring(0, 7)}`);
                setShowErrorModal(true);
                return;
            }
            // secondExchangeRate * firstConvertedAmount
            let secondConvertedAmount = Math.round((secondExchangeRate * firstConvertedAmount + Number.EPSILON) * 100) / 100;
            setExchangeRateText(formatNumberToInternational(firstExchangeRate) + '/'+formatNumberToInternational(secondExchangeRate));
            setConvertedKwanzaValue(secondConvertedAmount);
        } else {
            setCurrencyString(responseData.accountCurrency + '/AKZ');
            let exchangeRate = findExchangeRate(responseData.accountCurrency , currency, responseData.exchangeRates);
            if (!exchangeRate) {
                setErrorMessage(`Taxa de câmbio não encontrada para ${responseData.accountCurrency} para AKZ para o mês ${responseData.receivedDate.substring(0, 7)}`);
                setShowErrorModal(true);
                return;
            }
            setExchangeRateText(formatNumberToInternational(exchangeRate));
            setConvertedKwanzaValue(Math.round((exchangeRate * responseData.amount + Number.EPSILON) * 100) / 100);
        }
    }

    const findExchangeRate = (fromCurrency, toCurrency, exchangeRatesList) => {
        if (fromCurrency === toCurrency) {
            return 1;
        }
        const result = exchangeRatesList.find(
            (exchangeRate) =>
                exchangeRate.fromCurrency === fromCurrency &&
                exchangeRate.toCurrency === toCurrency
        );

        return result ? result.exchangeRate : null;
    }

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="p-2">
            <Loader show={loading}/>
            {showErrorModal &&
                <ErrorModal
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMessage={errorMessage}
                />
            }
            {/* Container for content */}
            <div className="relative text-black print:text-black">
                {/* Print Button */}
                <div className="absolute top-2 right-2 print:hidden">
                    <button
                        onClick={handlePrint}
                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                        Print
                    </button>
                </div>

                {/* Content starts */}
                <div className="flex flex-col items-center pt-4 print:pt-6">
                    {/* Header Section */}
                    <div className="text-center mb-4">
                    <div className="flex items-center justify-center h-[100px]">
  <img
    src={logo}
    alt="Logo"
    className="w-[60px] h-[80px] object-contain"
  />
</div>
                        <h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
                        <h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
                        <h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                        <h2 className="text-md font-bold mt-4">GUIA Nº {apiData.seqNumber}/ { apiData && apiData.receivedDate && apiData.receivedDate.substring(0, 4)} </h2>
                        {/* <h2 className="text-md uppercase font-bold mt-2" style={{ textAlign: 'left' }}>{orgName}</h2> */}

                    </div>

                    {/* Currency Information Section */}
                    <div className="w-full max-w-3xl flex justify-between items-center mb-4">
                        <div className="w-1/4 mx-auto text-center">
                            <p className="text-md font-bold">{apiData.accountCurrency}</p>
                            <div className="border rounded px-2 py-4 mt-1 w-30 mx-auto">{formatNumberToInternational(apiData.amount)}</div>
                        </div>


                        <div className="w-1/4 mx-auto text-center">
                            <p className="text-md font-bold">{currencyString}</p>
                            <div className="border rounded px-2 py-4 mt-1 w-30 mx-auto">{exchangeRateText}</div>
                        </div>
                        <div className="w-1/4 mx-auto text-center">
                            <p className="text-md font-bold">KWANZAS</p>
                            <div className="border rounded px-2 py-4 mt-1 w-30 mx-auto">{formatNumberToInternational(convertedKwanzaValue)}</div>
                        </div>
                    </div>

                    {/* Main Body Section */}
                    <div className="w-full max-w-3xl mb-8">
                        <p className="text-md leading-relaxed">
                            Debita-se ao encarregado da tesouraria do(a) EMBAIXADA DA REPÚBLICA
                            DE ANGOLA NO {COUNTRY} a quantia de:
                            <strong> {numberToWords(apiData.amount, apiData.accountCurrency)}</strong> proveniente de
                            &nbsp; {apiData.description} &nbsp;
                            mês de &nbsp; {apiData.receivedDate && getMonthNameInPortguese(apiData.receivedDate.substring(5, 7))} .
                        </p>
                        <p className="text-md mt-4 leading-relaxed">
                            Tóquio, {apiData.receivedDate && apiData.receivedDate.substring(8,10) } de {apiData.receivedDate && getMonthNameInPortguese(apiData.receivedDate.substring(5, 7))} de {apiData.receivedDate && apiData.receivedDate.substring(0,4) }
                        </p>
                    </div>

                    {/* Footer Section */}
                    <div className="w-full max-w-3xl flex justify-between mt-12">
                        <div className="text-center">
                            <p className="font-bold text-md mb-2 text-center">Visto</p>
                            <p className="mt-2 text-center">Embaixadora</p>
                            <p className="font-bold">{EMBAIXADOR}</p>

                            <hr className="border-t-2 border-black w-40 mx-auto mt-4"/>
                        </div>
                        <div className="text-center">
                            <p className="font-bold text-md mb-2 text-center">Recebi</p>
                            <p className="mt-2 text-center">O Adido Financeiro</p>
                            <p className="font-bold">{FINANCIAL_HEAD}</p>
                            <hr className="border-t-2 border-black w-40 mx-auto mt-4"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncomeReport;
